import { FC, PropsWithChildren, ReactNode } from 'react';

import { IconArrowLeft } from 'src/general/Icons/IconArrowLeft';
import { Button } from 'src/general/components/Button/Button';

type Props = { title: string; action?: ReactNode; hrefBack?: string };

export const ProductGridSection: FC<PropsWithChildren<Props>> = ({ children, title, hrefBack, action }) => {
  return (
    <section className="header-transparent c-se--sand c-se--default pt-24">
      <header className="mb-8 flex items-center justify-between">
        <div>
          {hrefBack && (
            <Button startIcon={<IconArrowLeft />} href={hrefBack} variant="tertiary">
              Back
            </Button>
          )}
          <h1 className="c-fs-h4 font-extrabold">{title}</h1>
        </div>
        <div className="fixed bottom-4 left-1/2 z-1 -translate-x-1/2 md:relative md:bottom-auto md:left-auto md:translate-x-0">
          {action}
        </div>
      </header>
      {children}
    </section>
  );
};
